import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';

import { DeleteScheduleExceptionProps } from './DeleteScheduleException.types';
import * as Styled from './DeleteScheduleException.styles';

export const DeleteScheduleException = ({
  onSubmit,
  onModalClose,
  onModalOpen,
  isModalOpen,
  isLoading,
}: DeleteScheduleExceptionProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();
  const isPermsDisabled = !perms?.[Functionality.HARMONOGRAMY]?.edit;

  return (
    <>
      <Styled.TrashIcon
        disabled={isPermsDisabled}
        onClick={isPermsDisabled ? undefined : onModalOpen}
        tabIndex={isPermsDisabled ? -1 : 0}
      />

      <ActionModal
        header={formatMessage({ id: AppMessages['schedule.exceptions.delete.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        size="medium"
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['common.delete'] })}
      >
        <ActionModal.Text>{formatMessage({ id: AppMessages['schedule.exceptions.delete.text'] })}</ActionModal.Text>
      </ActionModal>
    </>
  );
};
